import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import HandleErrorService from '../../app/service/handleErrorService'
import ConstantsUtil from '../../context/constantsUtil'
import GeneralServices from '../../app/service/generalServices'
import * as popUp from '../toastr'
import ConfirmationDialog from '../confirmationDialog'
import TooltipButton from '../tooltipButton'
import CustomHighlighter from '../customHighlighter'
import TipoDreCompetenciaService from '../../app/service/contasAPagar/tipoDreCompetenciaService'
import CadastroContasAPagarService from '../../app/service/central/cadastroContasAPagarService'
import CreateOrUpdateTipoDreCompetenciaDialog from './createOrUpdateTipoDreCompetenciaDialog'
import AuthService from '../../app/service/authService'

class TipoDreCompetenciaTable extends React.Component {

    constructor(){
        super()
        this.tipoDreCompetenciaService = new TipoDreCompetenciaService()
        this.cadastroContasAPagarService = new CadastroContasAPagarService()
    }

    state = {
        list: [],
        selectedItem: {},
        
        tipoDreCompetenciaToEdit: '',
        displayEditDialog: false,
        
        tipoDreCompetenciaToDelete: '',
        displayDeleteDialog: false,
        
        // forceUpdate: false,
        loading: false,

    }


    componentDidMount(){
        this.search()
    }

    search = () => {
        this.setState({loading: true})
        this.tipoDreCompetenciaService.search()
        .then(response => {
            this.setState({list: response.data})
        })
        .catch(error => {
            HandleErrorService.handleChange(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    edit = async (tipoDreCompetencia) => {
        // console.log("edit tipoProduto: ", tipoProduto)
        await this.setState({tipoDreCompetenciaToEdit: JSON.parse(JSON.stringify(tipoDreCompetencia))})
        await this.setState({forceUpdate: true})
        this.setState({displayEditDialog: true})
    }

    delete = async (tipoDreCompetencia) => {
        // console.log("edit tipoProduto: ", tipoProduto)
        await this.setState({tipoDreCompetenciaToDelete: JSON.parse(JSON.stringify(tipoDreCompetencia))})
        await this.setState({forceUpdate: true})
        this.setState({displayDeleteDialog: true})
    }

    doneForceUpdate = () => {
        this.setState({forceUpdate: false})
    }

    isEditDialogOpen = () => {
        return this.state.displayEditDialog
    }

    isDeleteDialogOpen = () => {
        return this.state.displayDeleteDialog
    }

    hideDialogs = () => {
        this.setState({
            displayEditDialog: false,
            tipoDreCompetenciaToEdit: '',
            displayDeleteDialog: false,
            tipoDreCompetenciaToDelete: '',
        })
    }

    handleSelectionChange = (event) => {
        this.setState({selectedItem: event.value})
        this.props.handleSelectionChange(event.value)
    }

    confirmDelete = () => {
        AuthService.startBlockUi()
        return this.cadastroContasAPagarService.deleteTipoDreCompetenciaByUuid(this.state.tipoDreCompetenciaToDelete.id)
        .then(response => {
            this.hideDialogs()
            popUp.successPopUp("Deletado com sucesso!")
            this.search()
        })
        .catch(error => 
            HandleErrorService.handleError(error)
        )
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    render() {

        const renderConfimationDeleteDialog = () => {
            return (
                <ConfirmationDialog
                    visible={this.state.displayDeleteDialog}
                    header={`Deletar ${this.state.tipoDreCompetenciaToDelete.descricao}`}
                    confimationMessage={"Deseja Confirmar?"}
                    confirm={this.confirmDelete}
                    hide={this.hideDialogs}
                    width={'30%'}
                />                  
            )
        }

        const actionBody = (selectedTipoDreCompetencia) => {
            if(!selectedTipoDreCompetencia.fixo)
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip = "Editar Tipo DRE Competência"
                        icon={<i className="pi pi-pencil" style={{fontSize: '1em'}}></i>}
                        onClick={() => this.edit(selectedTipoDreCompetencia)}
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                    />
                    <TooltipButton
                        tooltip = "Excluir Tipo DRE Competência"
                        className="p-button-danger right-button"
                        icon={<i className="pi pi-trash" style={{fontSize: '1em'}}></i>}
                        onClick={() => this.delete(selectedTipoDreCompetencia)}
                        style={ {maxHeight: '25px', maxWidth: '25px'} }
                    />
                </React.Fragment>
            );
        }

        return (
            <div className="">
            <div className="card">

                <DataTable
                    // ref={this.dt}
                    value={this.state.list}
                    className="p-datatable-sm small-font"
                    rowHover
                    emptyMessage="Não há nenhum cadastrado"
                    selection={this.state.selectedItem}
                    onSelectionChange={this.handleSelectionChange}
                    // scrollable
                    // scrollHeight="500px"
                    loading={this.state.loading}
                    dataKey="id"
                    // paginator rows={25} rowsPerPageOptions={[5, 10, 25]}
                    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    // currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} contas bancárias"
                >

                    <Column selectionMode="single" headerStyle={{ width: '3rem' }} />

                    <Column field="descricao" header="Descrição" sortable
                        body={rowData => 
                            <CustomHighlighter
                                searchWords={[this.props.searchText]}
                                textToHighlight={rowData.descricao}
                            />
                        }                    
                    />

                    <Column field="fixo" header="Fixo" sortable
                        body={rowData => rowData.fixo ? 'Sim' : 'Não'}
                    />

                    <Column header="Ações" body={actionBody} style ={ {width: '140px'} }
                    />

                </DataTable>
            </div>

            <CreateOrUpdateTipoDreCompetenciaDialog
                visible={this.state.displayEditDialog}
                tipo={this.props.tipo}
                isEdit
                hideDialog={this.hideDialogs}
                tipoDreCompetencia={this.state.tipoDreCompetenciaToEdit}
                search={this.search}
                forceUpdate={this.state.forceUpdate}
                doneForceUpdate={this.doneForceUpdate}
            />            

            {renderConfimationDeleteDialog()}

            </div>
        )
    }
}

export default TipoDreCompetenciaTable